import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import progress1Img from "../../../../assests/images/progress1.png";
import progress2Img from "../../../../assests/images/progress2.png";
import progress3Img from "../../../../assests/images/progress3.png";
import progress4Img from "../../../../assests/images/progress4.png";

const ProgressContent = () => (
  <ContentCard
    title="THE PROGRESS"
    id="progress"
    image={progress1Img}
    imageTtitle="Our Production Place"
    frontText="By now we already have figured out: delivery to the customer, product design and pattern,
                  sewing factory, ... "
    backTextOne="By now we already have figured out: shipment and delivery to the customer, product design and pattern, sewing factory, spinning mill for our fabrics, dying house, wash house, printing factory, factory for the embroidery, sources for the accessories, the label factory and our online webshop and especially our configuration tool. "
    backTextTwo="We appreciate the support of so many people from different sectors, experiences and countries. We are thankful for every help, idea, criticism or warnings in order to avoid unnecessary mistakes. Of course not everyone wanted to share their business insights with us. But it is quiet amazing that the majority of the people enjoys to help, when you knock at their doors and just ask."
    backTextThree="We are 100 % bootstrapping and learning everything from scratch. So we know we would not have come up to this point, if every support would have come with a bill. We thank everybody who is generous enough to help and to believe in our mission."
    imageBack1={progress4Img}
    imageTitle1="Spinning Mill"
    imageBack2={progress3Img}
    imageTitle2="Embroidery"
    imageBack3={progress2Img}
    imageTitle3="Shopping Stock"
    caption="At the beginning we thought we would need to source our first fabrics from stock since we are not a huge company that can order thousands of kilograms. After traveling from one Mauritian factory to another we learned that there actually are spinning mills that will produce our unique fabrics in high quality, even though we are a startup with small orders."
  />
);

export default ProgressContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Progress.js